import { Delete } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import HttpService from "../../../../hooks/Https-services";
import useConfig from "../../../../hooks/useConfig";
import PageRoutes, { APIRoutes } from "../../../../utils/constants";
import EditIcon from "@mui/icons-material/Edit";
import LoadingContext from "../../../../Common/Contex/LoadingContex";
const StatusBox = ({ data }: any) => {
  const configData = useConfig();
  const { isRefresh, setIsRefresh }: any = useContext(LoadingContext);
  const navigate = useNavigate();
  const handleRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  const handleUnpublish = async (id: any) => {
    try {
      const res = await HttpService.post(
        APIRoutes.UnPublishSlider.replace(":id", id),
        {}
      );

      handleRefresh();
    } catch (error) {}
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handlePublish = async (id: any) => {
    try {
      const res = await HttpService.post(
        APIRoutes.PublishSlider.replace(":id", id),
        {}
      );
      handleRefresh();
    } catch (error) {}
  };
  const handelDeleteSlider = async (id: any) => {
    try {
      const res = await HttpService.post(
        APIRoutes.DeleteSliderById.replace(":id", id),
        {}
      );
      handleRefresh();
    } catch (error) {}
  };
  return (
    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
      <button
        onClick={() => {
          if (data?.row?.original?.IsActive) {
            handleUnpublish(data?.row?.original?.ID);
          } else {
            handlePublish(data?.row?.original?.ID);
          }
        }}
        style={{
          cursor: "pointer",
          width: "200px",
        }}
        className={configData.buttonCommonClass}
      >
        {data?.row?.original?.IsActive ? "Move to Trash" : "Make Available"}
      </button>{" "}
      <button
        onClick={() =>
          navigate(
            PageRoutes.EditSliderSetting.replace(":id", data?.row?.original?.ID)
          )
        }
        style={{
          cursor: "pointer",
          width: "50px",
        }}
        className={configData.buttonCommonClass}
      >
        <EditIcon />
      </button>
      <button
        onClick={() => handelDeleteSlider(data?.row?.original?.ID)}
        style={{
          cursor: "pointer",
          width: "50px",
        }}
        className={configData.buttonCommonClass}
      >
        <Delete />
      </button>
    </Box>
  );
};
export default StatusBox;
